"use strict";Object.defineProperty(exports, "__esModule", {value: true});const GUIDRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

 const isGUIDValid = (str) =>
  !!(str && str.length === 36 && GUIDRegex.test(str)); exports.isGUIDValid = isGUIDValid
